var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.available)?_c('button',{staticClass:"btn mr-1",class:_vm.btnNextEstagio.class,on:{"click":function($event){return _vm.nextEstagio()}}},[_c('i',{staticClass:"fas mr-2",class:_vm.btnNextEstagio.icone}),_vm._v("\n\t"+_vm._s(_vm.btnNextEstagio.nome)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }